module.exports = __webpack_public_path__ + "static/media/heart7.2da3df2a.svg";